module.exports = __webpack_public_path__ + "img/logo-lan-warna.7e6bec92.png";